import React, { Component } from 'react';
import { BrowserRouter as Router, Switch, Route, Link } from 'react-router-dom';

class Navbar extends Component {
	render() {
		return (
			<div>
				{' '}
				<nav className='navbar navbar-inverse'>
					<div className='container-fluid'>
						<div className='navbar-header'>
							<button
								type='button'
								className='navbar-toggle'
								data-toggle='collapse'
								data-target='#myNavbar'
							>
								<span className='icon-bar' />
								<span className='icon-bar' />
								<span className='icon-bar' />
							</button>
							<Link className='navbar-brand' to='/'>
								News
							</Link>
						</div>
						<div className='collapse navbar-collapse' id='myNavbar'>
							<ul className='nav navbar-nav'>
								<li className='active'>
									<Link to='/'>Home</Link>
								</li>
								<li className='active'>
									<Link to='/developer'>Developer</Link>
								</li>
							</ul>
						</div>
					</div>
				</nav>
			</div>
		);
	}
}

export default Navbar;
